import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { ClassesTable } from './ClassesTable';
import { ClassPage } from './ClassPage';

export const ClassesRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={ClassesTable} />
                <Route exact path={`${path}/:classUuid`} component={ClassPage} />
            </Switch>
        </>
    );
};
